import { type JSX } from "react";
import { OfferEditableWrap } from "@/components/ClientOfferView";
import styles from "@/components/ClientOfferView.module.css";
import type { OfferSectionProps } from "@/components/offer/offerDocumentTypes";

function shouldHide(typeRaw: string | undefined): boolean {
  if (!typeRaw) return true;
  const normalized = typeRaw.trim().toLowerCase();
  return normalized === "none" || normalized === "hidden" || normalized === "nie pokazuj";
}

export function WarrantySection({ offerData }: OfferSectionProps): JSX.Element | null {
  if (shouldHide(offerData.warrantyType)) return null;

  const warrantyText = offerData.warrantyType?.trim() || "Gwarancja wykonawcy";
  const warrantyNotes = offerData.warrantyNotes?.trim();
  const onChange = offerData.onWarrantyTypeChange;

  return (
    <section className={styles.assumptions}>
      <div>
        <h2 className={styles.assumptionsHeading}>
          Gwarancja
          <br />
          wykonania
        </h2>
      </div>
      <ul className={styles.assumptionsList}>
        <li className={styles.assumptionItem}>
          {onChange ? (
            <OfferEditableWrap enabled className={styles.assumptionEditableWrap}>
              <span
                contentEditable
                spellCheck={false}
                suppressContentEditableWarning
                onBlur={(e) => onChange(e.currentTarget.textContent?.trim() || undefined)}
              >
                {warrantyText}
              </span>
            </OfferEditableWrap>
          ) : (
            <span>{warrantyText}</span>
          )}
        </li>
        {warrantyNotes ? (
          <li className={styles.assumptionItem}>
            <span>{warrantyNotes}</span>
          </li>
        ) : null}
      </ul>
    </section>
  );
}
